import React from 'react'
import ContactForm from './ContactForm'
import OfficeMapSection from './OfficeMapSection'

function ContactUs() {
  return (
    <>
    <ContactForm />
    <OfficeMapSection />
    </>
  )
}

export default ContactUs